/* eslint-disable */
import dicts from './example'

// 社会服务工作记录-表单
export const branchSocialForm = {
    attrs: {
        labelWidth: '180px',
        'label-position': 'left',
        rules: {
            // brandInfo: [
            //     { required: true, message: '请输入', trigger: 'blur' },
            // ],
            // honour: [{ required: true, message: '请输入', trigger: 'blur' }],
            category: [
                {
                    required: true,
                    message: '请选择',
                    trigger: 'change',
                },
            ],
            // carryTime: [
            //     {
            //         required: true,
            //         message: '请选择',
            //         trigger: 'change',
            //     },
            // ],
        },
    },
    items: [
        {
            label: '已有社会服务品牌名称',
            prop: 'brandInfo',
            maxlength: 100,
            showWordLimit: true,
            clearable: true,
        },
        {
            type: 'select',
            label: '持续开展时间',
            prop: 'carryTime',
            options: dicts.carryTime(),
        },
        {
            type: 'select',
            label: '品牌领域',
            prop: 'category',
            options: dicts.categoryBrand(),
        },
        {
            label: '受到有关部门鼓励表彰',
            prop: 'honour',
            maxlength: 100,
            showWordLimit: true,
            clearable: true,
        },
        {
            type: 'radio',
            label: '是否推荐至数字驾驶舱-社会服务创新品牌',
            prop: 'isRecomment',
            initValue: 1,
            options: [
              {
                label: '是',
                value: 1,
              },
              {
                label: '否',
                value: 0,
              },
            ],
            attrs: {
                'label-width': '300px'
            }
        }
    ]
}

// 社会服务工作记录-表格
export const branchSocialCols = [
    {
        title: '已有社会服务品牌名称',
        key: 'brandInfo',
        tooltip: true,
        minWidth: 180,
    },
    {
        title: '持续开展时间',
        slot: 'carryTime',
        tooltip: true,
        width: 150,
    },
    {
        title: '品牌领域',
        slot: 'category',
        width: 120,
    },
    {
        title: '受到有关部门鼓励表彰',
        key: 'honour',
        width: 240,
    },
    {
        title: '是否推荐至数字驾驶舱',
        slot: 'isRecomment',
        width: 200,
    },
    {
        title: '操作',
        slot: 'operation',
        width: 160,
        fixed: 'right',
        align: 'center'
    }
]
